import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Plus, ArrowUpRight } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { euro, TYPE_LABEL } from "@/lib/api";

const TYPE_DOT = { physique: "bg-[var(--ink)]", numerique: "bg-[var(--sage)]", affiliation: "bg-[var(--terra)]" };

export const ProductAction = ({ p, full = false }) => {
  const { add } = useCart();
  const base = `inline-flex items-center justify-center gap-2 rounded-full text-sm transition-colors duration-300 ${full ? "w-full py-4" : "px-4 py-2.5"}`;
  if (p.type === "affiliation")
    return (
      <a href={p.affiliate_url} target="_blank" rel="sponsored noopener noreferrer" data-testid={`affiliate-link-${p.id}`}
        className={`${base} border border-[var(--ink)] hover:bg-[var(--ink)] hover:text-[var(--bone)]`}>
        {p.partner === "Amazon" ? "Voir le prix sur Amazon" : `Découvrir ${p.partner}`} <ArrowUpRight className="h-4 w-4" />
      </a>
    );
  return (
    <button data-testid={`add-to-cart-${p.id}`} onClick={() => add(p)}
      className={`${base} bg-[var(--ink)] text-[var(--bone)] hover:bg-[var(--terra)]`}>
      <Plus className="h-4 w-4" /> Ajouter
    </button>
  );
};

export const ProductCard = ({ p, i = 0 }) => (
  <motion.article
    data-testid={`product-card-${p.id}`}
    layout
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.1 }}
    transition={{ duration: 0.8, delay: (i % 3) * 0.08, ease: [0.22, 1, 0.36, 1] }}
    className="group flex flex-col"
  >
    <Link to={`/produit/${p.id}`} data-testid={`product-link-${p.id}`} className="relative block overflow-hidden rounded-[20px] bg-[var(--bone-2)]">
      <div className="aspect-[4/5] overflow-hidden">
        <img src={p.image} alt={p.name} loading="lazy"
          className="h-full w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-[1.06]" />
      </div>
      <span className="absolute left-4 top-4 flex items-center gap-2 rounded-full bg-[#FBF9F5]/90 px-3 py-1.5 text-[11px] font-medium backdrop-blur">
        <span className={`h-1.5 w-1.5 rounded-full ${TYPE_DOT[p.type]}`} /> {TYPE_LABEL[p.type]}
      </span>
      <span className="absolute right-4 top-4 rounded-full bg-[#1C1917]/80 px-3 py-1.5 text-[11px] text-[var(--bone)] backdrop-blur">{p.badge}</span>
    </Link>
    <div className="mt-5 flex items-start justify-between gap-4">
      <div className="min-w-0">
        <Link to={`/produit/${p.id}`} className="font-display text-xl leading-snug hover:text-[var(--terra-deep)] transition-colors">{p.name}</Link>
        <p className="mt-1 text-xs text-[var(--muted)]">{p.type === "affiliation" ? `Chez ${p.partner}` : p.type === "numerique" ? "Livraison par email" : "Expédié par notre fournisseur"}</p>
      </div>
      {p.price != null && <p data-testid={`product-price-${p.id}`} className="font-display shrink-0 text-xl">{euro(p.price)}</p>}
    </div>
    <div className="mt-4"><ProductAction p={p} /></div>
  </motion.article>
);
